<template>
  <div>
    <!-- :get-form-data="fromData" -->
    <list
      row-key="UserId"
      ref="list"
      unit="客户分类存货折扣价"
      :page="page"
      show-checkbox
      :show-query="false"
      :query-params="params"
      :get-data-func="getDateFunc"
      @check-change="checkChange"
       urlHash="business/sales/salemanage/clientinventory"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>

      <template slot="table">
        <slot name="column"></slot>
      </template>
    </list>
  </div>
</template> 
<script>
import listMixin from "@/mixins/trend/list";
import list from "@/components/common/trendsTable/list";
export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      api: require("@/api/sy/dictionary").default,
      productApi: require("@/api/ba/product").default,
      params: {
        PuName: "",
        SolutionsName: "",
      },
      puOption: [],
      ids: [],
      tableList: [],
    };
  },
  methods: {
    getDateFunc() {
      return new Promise((resolve) => {
        this.api.list({ Code: "ProcessStage" }).then((res) => {
          this.tableList = JSON.parse(JSON.stringify(res.Data));
          resolve({ Data: res.Data, Count: res.Count, Code: res.Code });
        });
      });
    },
    checkChange(ids) {
      this.ids = ids.map((v) => {
        return v.SolutionsName;
      });
    },
    _del() {
      if (this.ids.length === 0) {
        this.$message({ type: "warning", message: "请选择删除的数据" });
        return;
      }
      this.$confirm("确定删除这些记录?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.api.del({ ids: this.ids }).then((res) => {
          if (res.Code === 0) {
            this.$message({ type: "success", message: res.Mes });
            this.reload();
          } else {
            this.$message({ type: "warning", message: res.Mes });
          }
        });
      });
    },
  },
};
</script>
